/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import BookshelfPage from './components/BookshelfPage';
import BookshelvesUserPage from './components/BookshelvesUserPage';
import BookshelvesPage from './components/BookshelvesPage';
import OwnBookshelvesPage from './components/OwnBookshelvesPage';

export default function (): void {
	app.routes.book_collections = { path: '/book_collections', component: OwnBookshelvesPage };
	app.route.book_collections = (params) => app.route('book_collections', params);

	app.routes.all_book_collections = { path: '/all_book_collections', component: BookshelvesPage };
	app.route.all_book_collections = (params) => app.route('all_book_collections', params);

	app.routes.book_collection = { path: '/book_collections/:id', component: BookshelfPage };
	app.route.book_collection = (bookshelf, params) => {
		const slug = bookshelf.slug();
		return app.route('book_collection', {
			id: `${bookshelf.id()}${slug.trim() ? `-${slug}` : ''}`,
			...params,
		});
	};

	// TODO : make BookshelfBookPage

	app.routes['user.book_collections'] = {
		path: '/u/:username/book_collections',
		component: BookshelvesUserPage,
	};
}
